import { CREATE_CREDIT_NOTE, FETCH_CREDIT_NOTE, FETCH_CREDIT_NOTES } from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// CREATE_CREDIT_NOTE
// --------------------------------------------------------------------------
export const createCreditNote = (data) => ({
  type: CREATE_CREDIT_NOTE.init,
  payload: API.createCreditNote(data),
});

export const createCreditNoteSuccess = (data) => ({
  type: CREATE_CREDIT_NOTE.success,
  payload: data,
});

export const createCreditNoteFailure = (error) => ({
  type: CREATE_CREDIT_NOTE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_CREDIT_NOTE
// --------------------------------------------------------------------------
export const fetchCreditNote = (id) => ({
  type: FETCH_CREDIT_NOTE.init,
  payload: API.fetchCreditNote(id),
});

export const fetchCreditNoteSuccess = (data) => ({
  type: FETCH_CREDIT_NOTE.success,
  payload: data,
});

export const fetchCreditNoteFailure = (error) => ({
  type: FETCH_CREDIT_NOTE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_CREDIT_NOTES
// --------------------------------------------------------------------------
export const fetchCreditNotes = (page, invoiceNumber, creditNoteNumber, creditNoteDate, vendor) => ({
  type: FETCH_CREDIT_NOTES.init,
  payload: API.fetchCreditNotes(page, invoiceNumber, creditNoteNumber, creditNoteDate, vendor),
});

export const fetchCreditNotesSuccess = (data) => ({
  type: FETCH_CREDIT_NOTES.success,
  payload: data,
});

export const fetchCreditNotesFailure = (error) => ({
  type: FETCH_CREDIT_NOTES.failure,
  payload: error,
});
